<template>
  <search-body />
</template>

<script>
import AgeTechServiceModify from "@/components/ageTechService/AgeTechServiceModify.vue";

export default {
  name: "AgeTechService",
  components: {
    "search-body": AgeTechServiceModify,
  },
};
</script>
